import httpClient from "../httpClient";

const END_POINT = "/group";

const getGroups = () => httpClient.get(`${END_POINT}`);

export { getGroups };
